export default __webpack_public_path__ + "assets/completion-mark.0ecaedef.svg";